module.exports = __webpack_public_path__ + "static/media/icon_selected_tablecharts.c00554ad.svg";